var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"98b24a0b8434f619d2a218ff16637aedb7bfa31a"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/**
 * Sentry Client Configuration
 *
 * ブラウザ（クライアントサイド）でのSentry初期化設定
 */

import * as Sentry from '@sentry/nextjs';

import { SENTRY_CONFIG } from './src/lib/sentry/config';

Sentry.init({
  dsn: SENTRY_CONFIG.dsn,
  environment: SENTRY_CONFIG.environment,
  enabled: SENTRY_CONFIG.enabled,

  // パフォーマンストレーシング
  tracesSampleRate: SENTRY_CONFIG.tracesSampleRate,

  // 分散トレーシング: マッチする URL への fetch/XHR に sentry-trace/baggage を付与し
  // BE 側の trace と1本に繋ぐ（GraphQL API は別オリジンのため明示指定が必須）
  tracePropagationTargets: SENTRY_CONFIG.tracePropagationTargets,

  // Session Replay統合
  replaysSessionSampleRate: SENTRY_CONFIG.replaysSessionSampleRate,
  replaysOnErrorSampleRate: SENTRY_CONFIG.replaysOnErrorSampleRate,

  integrations: [
    // pageload/navigation/Web Vitals の自動計測 + fetch/XHR の span 化（trace 伝播の起点）
    Sentry.browserTracingIntegration(),
    // NOTE: 直近エラーが頻発しているため、情報を取得しておく
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    // console.errorをSentryにキャプチャ
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
  ],

  // デバッグモード（Sentry有効 かつ 開発環境のみ）
  debug: SENTRY_CONFIG.enabled && process.env.NODE_ENV === 'development',

  // PIIフィルタリング（個人情報保護）
  beforeSend(event, hint) {
    // 開発環境ではコンソールに出力
    if (process.env.NODE_ENV === 'development') {
      console.log('[Sentry Event]', event);
    }

    // Sentry自身のエラーをフィルタリング
    if (event.exception?.values?.[0]?.value?.includes('Sentry')) {
      return null;
    }

    // PII（個人識別情報）をマスクする関数
    const redactPII = (str: string | undefined): string | undefined => {
      if (!str) return str;
      return str
        .replace(/[\w.+-]+@[\w.-]+\.[a-zA-Z]{2,}/g, '[EMAIL_REDACTED]')
        .replace(/\b\d{3}-\d{4}-\d{4}\b/g, '[PHONE_REDACTED]')
        .replace(/\b\d{2,4}-\d{2,4}-\d{4}\b/g, '[PHONE_REDACTED]');
    };

    // メインメッセージのマスク
    if (event.message) {
      event.message = redactPII(event.message);
    }

    // 例外メッセージのマスク
    if (event.exception?.values) {
      event.exception.values = event.exception.values.map(exception => ({
        ...exception,
        value: redactPII(exception.value),
      }));
    }

    // Breadcrumbsのマスク
    if (event.breadcrumbs) {
      event.breadcrumbs = event.breadcrumbs.map(crumb => ({
        ...crumb,
        message: redactPII(crumb.message),
        data: crumb.data
          ? Object.fromEntries(
              Object.entries(crumb.data).map(([key, value]) => [
                key,
                typeof value === 'string' ? redactPII(value) : value,
              ]),
            )
          : crumb.data,
      }));
    }

    // リクエストデータのマスク
    if (event.request?.data) {
      const dataStr = typeof event.request.data === 'string' ? event.request.data : JSON.stringify(event.request.data);
      event.request.data = redactPII(dataStr);
    }

    return event;
  },
});
